module.exports = __webpack_public_path__ + "img/温婉.5792254b.png";